/* eslint-disable @nx/enforce-module-boundaries */
import { useDisclosure } from '@mybridge/ui/hooks';
import { useRouter } from 'next/router';
// import { forwardRef, useEffect } from 'react';
import { forwardRef, useEffect, useState, useRef } from 'react';
import { DashboardPostModal } from '../post-modal';

export const openGlobalPostModal = ({ post, openMedia }) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('open-global-post-modal', {
        detail: { post, openMedia },
      })
    );
  }
};

export const GlobalPostContainer = forwardRef(({ ...props }, ref) => {
  const { query, push } = useRouter();
  // const post = query?.post;
  const queryPost = query?.post;
  const postModalDisc = useDisclosure();
  const [activePost, setActivePost] = useState(null);
  const [activeOpenMedia, setActiveOpenMedia] = useState(null);
  const prevUrlRef = useRef(null);

  useEffect(() => {
    const handleOpenEvent = (e) => {
      const { post: postData, openMedia } = e.detail || {};
      if (postData) {
        setActivePost(postData);
        setActiveOpenMedia(openMedia || null);
        prevUrlRef.current = window.location.pathname + window.location.search;

        const targetUrl = `/post/${postData.id || postData.slug}`;

        window.history.pushState(
          { isGlobalPostModal: true, prevUrl: prevUrlRef.current },
          '',
          targetUrl
        );

        postModalDisc.onOpen();
      }
    };

    const handlePopState = (e) => {
      if (postModalDisc.isOpen) {
        setActivePost(null);
        setActiveOpenMedia(null);
        postModalDisc.onClose();
      }
    };

    window.addEventListener('open-global-post-modal', handleOpenEvent);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('open-global-post-modal', handleOpenEvent);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [postModalDisc]);

  useEffect(() => {
    if (queryPost?.length) {
      postModalDisc.onOpen();
    } else if (!activePost) {
      postModalDisc.onClose();
    }
  }, [queryPost, activePost]);

  const handleClose = () => {
    postModalDisc.onClose();
    setActivePost(null);
    setActiveOpenMedia(null);

    if (window.history.state?.isGlobalPostModal) {
      window.history.back();
    } else if (queryPost) {
      push('/');
    }
  };

  const currentPostId = activePost?.id || queryPost;

  return (
    <>
      {/* {post?.length > 0 ? ( */}
      {currentPostId && postModalDisc.isOpen ? (
        <DashboardPostModal
          {...postModalDisc}
          onClose={handleClose}
          postId={currentPostId}
          initialPostData={activePost}
          openMedia={activeOpenMedia}
        />

      ) : (
        ''
      )}
    </>
  );
});
